import { action, computed, observable, runInAction } from "mobx";
import { IViewModel } from "mobx-utils";
import { api } from "../../api";
import {
  IIcmsClassificacao,
  IImportErro,
  INotificacaoErro,
  ISomaNotas,
  newINotificacaoErro,
  newISomaNotas,
} from "../../model";
import { IHistoricoNotas } from "../../model";
import { toast } from "react-toastify";
const numeral = require("numeral");

export class _CentralStore {
  obs = observable({
    loaded: false as boolean,
    imps: new Map() as Map<number, IImportErro & IViewModel<IImportErro>>,
    filter: "" as string,
    currentPage: 1 as number,
    total_calculado: 0 as number,
    total_nao_calculado: 0 as number,
    erros_nfe: 0 as number,
    empresas_erros_nfe: [] as any[],
    manifestacao_t_l: null as IHistoricoNotas,
    tarefas_calc: [] as any,
    tarefas_sitfis: { status: [], julgamento: [] } as any,
    tarefas_cnds: { status: [], certidao: [] },
    total_sem_icms: 0 as number,
    total_valor_sem_icms: 0 as number,
    empresasICMS: [] as any[],
    total_st_icms: 0 as number,
    total_valor_st_icms: 0 as number,
    empresasST: [] as any[],
    empresasGeral: [] as any[],
    resultCalculos: "" as string,
    resultDownloads: "" as string,
    resultICMS: "" as string,
    resultST: "" as string,
    empresa: "" as string,
    isNotificacao: false as boolean,
    notificacoes_configuradas: newINotificacaoErro() as INotificacaoErro,
    notificacoes_id: 0 as number,
    mensagens: [] as any[],
    empresasEspaco: [] as any[],
    soma_notas: newISomaNotas() as ISomaNotas,
    soma_notas_empresa: newISomaNotas() as ISomaNotas,
  })

  @action
  async load(): Promise<void> {
    if (this.obs.loaded) return;
    try {
      this.obs.loaded = true
      // Busco o total de erros por empresa
      let resp_erros = await api.get("/api/erros-conta");

      runInAction(() => {
        // Erros Calculo
        this.obs.total_calculado = resp_erros.data.relatorio_processos.valor_calculado;
        this.obs.total_nao_calculado = resp_erros.data.relatorio_processos.valor_nao_calculado;
        this.obs.erros_nfe = resp_erros.data.relatorio_processos.qta_calc;
        this.obs.empresas_erros_nfe = resp_erros.data.relatorio_processos.dados;

        this.obs.tarefas_calc = resp_erros.data.relatorio_processos.tarefas_calc;

        this.obs.tarefas_sitfis = { ...this.obs.tarefas_sitfis, ...resp_erros.data.relatorio_processos.tarefas_sitfis };
        this.obs.tarefas_cnds = resp_erros.data.relatorio_processos.tarefas_cnds

        this.obs.empresasEspaco = resp_erros.data.armazenamento;
        this.obs.soma_notas = { ...this.obs.soma_notas, ...resp_erros.data.soma_notas };

        this.obs.empresasGeral = [];

        resp_erros.data.relatorio_processos.dados?.forEach((obj) => {
          let total = parseInt(obj.calculo) + parseInt(obj.download_erros) + parseInt(obj.st) + parseInt(obj.icms);
          if (total != 0) {
            this.obs.empresasGeral.push(obj);
          }
        });

        // ICMS
        this.obs.total_sem_icms = resp_erros.data.relatorio_processos.qta_icms;
        this.obs.total_valor_sem_icms = resp_erros.data.relatorio_processos.sum_icms;
        this.obs.empresasICMS = [];
        resp_erros.data.relatorio_processos.dados?.forEach((obj) => {
          if (obj.icms > 0) {
            this.obs.empresasICMS.push(obj);
          }
        });

        // Substituição Tributária
        this.obs.total_st_icms = resp_erros.data.relatorio_processos.qta_st;
        this.obs.total_valor_st_icms = resp_erros.data.relatorio_processos.sum_st;
        this.obs.empresasST = [];
        resp_erros.data.relatorio_processos.dados?.forEach((obj) => {
          if (obj.st > 0) {
            this.obs.empresasST.push(obj);
          }
        });

        // Item ICMS
        // this.obs.icmsClassFilter = resp_erros.data.icms_classificacao;

        // Item ST
        // this.obs.stClassFilter = resp_erros.data.st_classificacao;
      });

    } catch (ex) {
      console.log("Erro ao consultar total de erros por empresa!")
    }
    this.obs.loaded = false
  }

  async loadNotificacao(): Promise<void> {
    try {
      let resp = await api.get("/api/notificacao/index");

      if (resp.data.length == 0) {
        this.obs.isNotificacao = false
      } else {
        this.obs.isNotificacao = true
      }

    } catch (ex) {
      toast.error("Erro ao consultar total de erros por empresa, tente novamente mais tarde.", {});
    }
  }

  @action
  setCurrentPage(page: number) {
    this.obs.currentPage = page;
  }

  @action
  setFilter(filter: any) {
    this.obs.filter = filter;
    return this.obs.filter.slice(filter);
  }

  @action
  filterEmpresa(cnpj: any) {
    this.obs.resultICMS = this.getICMS(cnpj);
    this.obs.resultCalculos = this.getCalculo(cnpj);
    this.obs.resultDownloads = this.getDownload(cnpj);
    this.obs.resultST = this.getST(cnpj);
  }

  getICMS(cnpj: string) {
    let result = this.obs.empresasGeral.find(x => x.cnpj == cnpj);
    if (result.icms > 0) {
      return "Possui " + result.icms + " itens pendentes, totalizando R$ " +
        numeral(result.valor_icms).format("0,0.00") + " sem classificação.";
    } else {
      return "Tudo está correto até o momento.";
    }
  }

  getST(cnpj: string) {
    let result = this.obs.empresasGeral.find(x => x.cnpj == cnpj);
    if (result.st > 0) {
      return "Possui " + result.st + " itens pendentes, totalizando R$ " +
        numeral(result.valor_st).format("0,0.00") + " sem classificação.";
    } else {
      return "Tudo está correto até o momento.";
    }
  }

  getCalculo(cnpj: string) {
    let result = this.obs.empresasGeral.find(x => x.cnpj == cnpj);

    if (result.calculo > 0) {
      return "Possui " + result.calculo + " NF-es não calculadas.";
    } else {
      return "Tudo está correto até o momento.";
    }
  }

  getDownload(cnpj: string) {
    let result = this.obs.empresasGeral.find(x => x.cnpj == cnpj);
    this.obs.empresa = result.razao_social;
    if (result.download_erros > 0) {
      return "Possui " + result.download_erros +
        " itens pendentes para download.";
    } else {
      return "Tudo está correto até o momento.";
    }
  }
  @action
  async buscaDadosNotificacao(): Promise<void> {
    try {
      let resp_notify = await api.get(`/api/notificacao/show`);
      runInAction(() => {
        if (resp_notify.data.status == "ok") {
          this.obs.notificacoes_configuradas = resp_notify.data.notificacao;
          this.obs.notificacoes_id = resp_notify.data.notificacao._id;
        } else {
          this.obs.notificacoes_configuradas = null;
        }
      });
    } catch (ex) {
      toast.error("Erro ao buscar notificações configuradas, tente novamente mais tarde.", {});
    }
  }

  async createNotificacao(
    meio: any,
    celular: string,
    email: string,
    periodicidade: string,
    dia: string,
    empresas: any,
    chat_id: string
  ) {
    try {
      let params = {
        meio_comunicacao: meio,
        celular: celular.replace(/[^\d]/g, ''),
        email: email,
        periodicidade: periodicidade,
        dia: dia,
        empresas: empresas,
        chat_id: chat_id
      };

      let resp = await api.post("/api/notificacao/save", params);
      runInAction(() => {
        if (resp.data === "Ok") {
          toast.success('Notificação salva com sucesso!', {});
        } else {
          toast.warning('Não foi possível cadastrar a notificação!', {});
        }
      });
    } catch (ex) {
      toast.error("Erro ao cadastrar notificação, tente novamente mais tarde.", {});
    }
  }

  async deleteNotificacoes(id: any): Promise<void> {
    try {
      let resp = await api.delete(`/api/notificacao/delete/${id}`);

      runInAction(() => {
        if (resp.data === "Ok") {
          toast.success('Notificação deletada com sucesso!', {});
          window.location.reload()
        } else {
          toast.warning('Não foi possível deletar notificação!', {});
        }
      });
    } catch (ex) {
      toast.error("Erro ao deletar Notificação, tente novamente mais tarde.", {});
    }
  }

  @computed
  get filtered(): IImportErro[] {
    let ret = [];
    for (let imp of this.obs.imps.values()) {
      let passesFilter = true;
      let filter = this.obs.filter.toUpperCase();

      if (filter) {
        passesFilter = imp.id != -1 ||
          imp.id != -1 ||
          imp.id != -1;
      }

      if (passesFilter) ret.push(imp);
    }
    return ret;
  }

  getPage(page: number, pageSize = 50): IImportErro[] {
    let start = (page - 1) * pageSize;
    let end = start + pageSize;
    return this.filtered.slice(start, end);
  }

  getAllPages(page: number, pageSize = 10000): IImportErro[] {
    let start = (page - 1) * pageSize;
    let end = start + pageSize;
    return this.filtered.slice(start, end);
  }

  async faturamento_empresa(cnpj: string, year: string) {

    let data = {
      cnpj: cnpj,
      year: year
    }

    let resp = await api.post("/api/faturamento/empresa", data);

    this.obs.soma_notas_empresa = newISomaNotas()

    this.obs.soma_notas_empresa = { ...this.obs.soma_notas_empresa, ...resp.data };

  }
}

export const CentralStore = new _CentralStore();
